import React, { useState } from 'react';
import { Icon, DatePicker } from 'antd';
import styles from './YearPickerField.module.scss';
import FormItem from '../FormItem/FormItem';

const YearPickerField = ({
  label,
  form,
  name,
  options,
  className,
  inline = false,
  colon = false,
  inputProps,
  onRemoveField,
  ...props
}) => {
  const { getFieldDecorator, setFieldsValue } = form;

  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (status) => {
    if (status) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  const handlePanelChange = (val) => {
    setFieldsValue({ [name]: val });
    setIsOpen(false);
  };

  const handleChange = () => {
    setFieldsValue({ [name]: null });
  };

  return (
    <FormItem {...props} colon={colon} label={label} className={className}>
      {getFieldDecorator(
        name,
        options
      )(
        <DatePicker
          {...inputProps}
          open={isOpen}
          mode="year"
          placeholder=""
          format="YYYY"
          onOpenChange={handleOpenChange}
          onPanelChange={handlePanelChange}
          onChange={handleChange}
          suffixIcon={<Icon type="down" />}
          className={styles.root}
        />
      )}
    </FormItem>
  );
};

export default YearPickerField;
